function faq(parentContainer = document, className = "faq") {

	const faq = document.getElementById("faq");

	if (faq == undefined) {
		return;
	}

	const faqItems = document.querySelectorAll('.faq-title');
	
	for (let i = 0; i < faqItems.length; i++) {
		const element = faqItems[i];
		element.addEventListener('click', () => {
			if(element.parentNode.className == 'faq-item'){
				element.parentNode.className = 'faq-item active';
			}else {
				element.parentNode.className = 'faq-item';
			}
		});
	}

}

module.exports = faq;


// WEBPACK FOOTER //
// ./resources/js/modules/faq.js